module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-turntable"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.truntable.activityBackground,
      "alt": ""
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "warp"
  }, [_c('img', {
    attrs: {
      "src": _vm.truntable.couponPicture,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-473d026c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activityTurntable.vue
// module id = 325
// module chunks = 1